import axios from "./axios";

export type SalterFarm = { id: number; name: string; initials: string };
export type SalterArea = { id: number; name: string; initials: string; farm_id: number };
export type Salter = {
  id?: number | null;
  user: { id: number; name: string; phone: string; profile_id?: number };
  farms: SalterFarm[];
  areas: SalterArea[];
};

export type SalterPayload = { user_id: number; farm_ids: number[]; area_ids: number[] };
export type SalterPage = {
  data: Salter[];
  current_page: number;
  total_pages: number;
  per_page: number;
  total: number;
};

function normalizePage(payload: any): SalterPage {
  const rows = payload?.data || payload?.content || (Array.isArray(payload) ? payload : []);
  return {
    data: rows,
    current_page: Number(payload?.current_page ?? (payload?.number != null ? payload.number + 1 : 1)),
    total_pages: Number(payload?.total_pages ?? payload?.totalPages ?? 1),
    per_page: Number(payload?.per_page ?? payload?.size ?? 20),
    total: Number(payload?.total ?? payload?.totalElements ?? rows.length),
  };
}

async function list(page: number, query?: string): Promise<SalterPage> {
  const { data } = await axios.get("/salters", { params: { page, per_page: 8, ...(query ? { query } : {}) } });
  return normalizePage(data);
}

async function listByFarm(farmId: number | string): Promise<Salter[]> {
  const perPage = 100;
  const getPage = async (page: number) => {
    const { data } = await axios.get("/salters", {
      params: { page, per_page: perPage, farm_id: farmId },
    });
    return normalizePage(data);
  };

  const firstPage = await getPage(1);
  if (firstPage.total_pages <= 1) return firstPage.data;

  const remainingPages = await Promise.all(
    Array.from({ length: firstPage.total_pages - 1 }, (_, index) =>
      getPage(index + 2),
    ),
  );

  return [firstPage, ...remainingPages].flatMap((page) => page.data);
}

function save(payload: SalterPayload, salterId?: number | null) {
  return salterId
    ? axios.patch(`/salters/${salterId}`, payload)
    : axios.post("/salters", payload);
}

export const salterService = { list, listByFarm, save };
